import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	modal: '',
	data: null,
}

const commonSlice = createSlice({
	name: 'common',
	initialState,
	reducers: {
		openModal: (state, action) => {
			state.modal = action.payload
		},
		closeModal: (state) => {
			state.modal = ''
		},
		setModalData: (state, action) => {
			state.data = action.payload
		},
	},
})

export const { openModal, closeModal, setModalData } = commonSlice.actions
export default commonSlice.reducer
